import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c3c3dfa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\97813\\Desktop\\汇智衣\\sd_hq_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3c3dfa"]])

export default __exports__